if (!customElements.get('tpt-shop-the-look-3')) {
  class TptShopTheLook3 extends HTMLElement {
    constructor() {
      super();
      this.ticking = false;
      this.handleWindowScroll = this.handleWindowScroll.bind(this);
    }

    connectedCallback() {
      this.scrollArea = this.querySelector('.tpt-shop-the-look_3_scroll-area');
      this.labels = this.querySelectorAll('.tpt-shop-the-look_3_label');
      this.sliders = this.querySelectorAll('.tpt-shop-the-look_3_slider');
      this.container = this.closest('.tpt-shop-the-look-3_container');
      
      // Detect layout mode
      this.isFullHeight = this.container?.classList.contains('tpt-shop-the-look-3-full-height--true');
      
      // Check if mobile
      this.checkMobile();
      window.addEventListener('resize', () => this.checkMobile());
      
      this.initLabelClick();
      this.initScrollSync();
    }

    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    }

    initLabelClick() {
      this.labels.forEach(label => {
        label.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          // MOBILE: Click any label -> scroll to scroll area
          if (this.isMobile) {
            if (this.scrollArea) {
              const scrollOffset = this.scrollArea.getBoundingClientRect().top + window.pageYOffset;
              window.scrollTo({
                top: scrollOffset - 20, // Small offset from top
                behavior: 'smooth'
              });
            }
            
            // Update active state
            this.labels.forEach(l => l.classList.remove('active'));
            label.classList.add('active');
            return;
          }
          
          // DESKTOP: Scroll to specific card
          const targetCardId = label.dataset.targetCard;
          const targetSlider = this.querySelector(`[data-card-id="${targetCardId}"]`);
          
          if (!targetSlider) return;

          if (this.isFullHeight) {
            // Full height mode: scroll window to center card in viewport
            const cardRect = targetSlider.getBoundingClientRect();
            const cardHeight = cardRect.height;
            const cardTop = cardRect.top + window.pageYOffset;
            const viewportCenter = window.innerHeight / 2;
            const cardCenter = cardHeight / 2;
            
            const targetTop = cardTop - viewportCenter + cardCenter;
            
            window.scrollTo({
              top: targetTop,
              behavior: 'smooth'
            });
          } else {
            // Fixed height mode: scroll inside container to center card
            if (this.scrollArea) {
              const cardHeight = targetSlider.offsetHeight;
              const cardTop = targetSlider.offsetTop;
              const scrollAreaHeight = this.scrollArea.offsetHeight;
              const scrollAreaCenter = scrollAreaHeight / 2;
              const cardCenter = cardHeight / 2;
              const targetOffset = cardTop - scrollAreaCenter + cardCenter;
              
              this.scrollArea.scrollTo({
                top: targetOffset,
                behavior: 'smooth'
              });
            }
          }

          // Update active state
          this.labels.forEach(l => l.classList.remove('active'));
          label.classList.add('active');
        });
      });
    }

    initScrollSync() {
      // Mobile: No scroll sync needed (cards are in column layout)
      if (this.isMobile) {
        return;
      }
      
      if (this.isFullHeight) {
        // Full height mode: listen to window scroll
        window.addEventListener('scroll', this.handleWindowScroll);
        // Initial check
        this.updateActiveLabelForWindow();
      } else {
        // Fixed height mode: listen to scroll area
        if (!this.scrollArea) return;
        
        this.scrollArea.addEventListener('scroll', () => {
          if (!this.ticking) {
            window.requestAnimationFrame(() => {
              this.updateActiveLabelForScrollArea();
              this.ticking = false;
            });
            this.ticking = true;
          }
        });
        // Initial check
        this.updateActiveLabelForScrollArea();
      }
    }

    handleWindowScroll() {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          this.updateActiveLabelForWindow();
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    updateActiveLabelForScrollArea() {
      if (!this.sliders || this.sliders.length === 0 || !this.scrollArea) return;

      const scrollAreaRect = this.scrollArea.getBoundingClientRect();
      const scrollAreaCenter = scrollAreaRect.top + scrollAreaRect.height / 2;
      
      let activeSlider = null;
      let minDistance = Infinity;

      this.sliders.forEach(slider => {
        const rect = slider.getBoundingClientRect();
        const sliderCenter = rect.top + rect.height / 2;
        const distance = Math.abs(sliderCenter - scrollAreaCenter);

        // Check if slider is visible in scroll area
        if (rect.top < scrollAreaRect.bottom && rect.bottom > scrollAreaRect.top) {
          if (distance < minDistance) {
            minDistance = distance;
            activeSlider = slider;
          }
        }
      });

      this.setActiveLabel(activeSlider);
    }

    updateActiveLabelForWindow() {
      if (!this.sliders || this.sliders.length === 0) return;

      const viewportCenter = window.innerHeight / 2;
      let activeSlider = null;
      let minDistance = Infinity;

      this.sliders.forEach(slider => {
        const rect = slider.getBoundingClientRect();
        const sliderCenter = rect.top + rect.height / 2;
        const distance = Math.abs(sliderCenter - viewportCenter);

        // Check if slider is visible in viewport
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          if (distance < minDistance) {
            minDistance = distance;
            activeSlider = slider;
          }
        }
      });

      this.setActiveLabel(activeSlider);
    }

    setActiveLabel(activeSlider) {
      if (activeSlider) {
        const cardId = activeSlider.dataset.cardId;
        
        this.labels.forEach(label => {
          if (label.dataset.targetCard === cardId) {
            label.classList.add('active');
          } else {
            label.classList.remove('active');
          }
        });
      }
    }

    disconnectedCallback() {
      if (this.isFullHeight) {
        window.removeEventListener('scroll', this.handleWindowScroll);
      } else if (this.scrollArea) {
        this.scrollArea.removeEventListener('scroll', this.updateActiveLabelForScrollArea);
      }
    }
  }

  customElements.define('tpt-shop-the-look-3', TptShopTheLook3);
}